<template>
  <div id="sheet">
    <div id="sheet-disp-area"
         @contextmenu.prevent>
      <svg xmlns="http://www.w3.org/2000/svg"
        id="sheet2"
        :width="svgWidth"
        :height="svgHeight"
        transform="scale(1, -1)"
        :viewBox="sheetViewBox"
        preserveAspectRatio="xMinYMax meet"
        @wheel="wheelOnSheet"
        @mousemove="mousemoveOnSheet"
        @mousedown="mousedownOnSheet"
        @mouseup="mouseupOnSheet"
      >
        <!-- 表題欄・外枠 -->
        <!--
        <g v-bind:class="{sheet_info: true, sheet_info_imp: isShowInfo}">
          <line
            v-for="(line, index) in sheetModel.titleAreaLineList"
            :key="'titleAreaLine_' + index"
            :x1="line.startX"
            :y1="line.startY"
            :x2="line.endX"
            :y2="line.endY"
            stroke="black"
            stroke-width="1px" />
          <g
            v-bind:class="{sheet_info: true, sheet_info_imp: isShowInfo}"
            v-for="(text, index) in sheetModel.titleAreaTextList"
            :key="'titleAreaText_' + index"
            :transform="'translate(' + text.x + ' ' + text.y + ') scale(1, -1)'">
            <text text-anchor="start" :font-size="text.font ? text.font : '12'" :font-weight="text.fontWeight ? 'bolder' : 'normal'">{{ text.text }}</text>
          </g>
        </g>
        -->
        <!-- コンバイン構成明細 -->
        <template v-bind:class="{sheet_info: true, sheet_info_imp: isShowInfo}">
          <g
            v-bind:class="{sheet_info: true, sheet_info_imp: isShowInfo}"
            v-for="(bom, index) in sheetModel.combineBomList"
            :key="'combineBomList_' + index"
            :transform="'translate(' + bom.startX + ' ' + bom.startY + ') scale(1, -1)'">
            <text x="10" :font-size="bom.font">{{ bom.no }}</text>
            <text x="30" :font-size="bom.font">{{ bom.itemName }}</text>
            <text x="130" :font-size="bom.font">{{ bom.size }}</text>
            <text x="230" :font-size="bom.font">{{ bom.quantity }}</text>
            <text x="260" :font-size="bom.font">{{ bom.itemNumber }}</text>
            <text x="360" :font-size="bom.font">{{ bom.cabinetPattern }}</text>
            <text x="440" :font-size="bom.font">{{ bom.otherItemNumber }}</text>
          </g>
        </template>
        <!-- パーツ構成明細 -->
        <template v-bind:class="{sheet_info: true, sheet_info_imp: isShowInfo}">
          <g
            v-for="(bom, index) in sheetModel.partsBomList"
            :key="'partsBomList_' + index"
            :transform="'translate(' + bom.startX + ' ' + bom.startY + ') scale(1, -1)'">
            <text x="10" :font-size="bom.font">{{ bom.no }}</text>
            <text x="30" :font-size="bom.font">{{ bom.partsName }}</text>
            <text x="130" :font-size="bom.font">{{ bom.itemNumber }}</text>
            <text x="230" :font-size="bom.font">{{ bom.size }}</text>
            <text x="330" :font-size="bom.font">{{ bom.quantity }}</text>
            <text x="360" :font-size="bom.font">{{ bom.figureNumber }}</text>
          </g>
        </template>
        <!-- 金具構成明細 -->
        <template v-bind:class="{sheet_info: true, sheet_info_imp: isShowInfo}">
          <g
            v-for="(bom, index) in sheetModel.fittingBomList"
            :key="'fittingBomList_' + index"
            :transform="'translate(' + bom.startX + ' ' + bom.startY + ') scale(1, -1)'">
            <text x="10" :font-size="bom.font">{{ bom.no }}</text>
            <text x="30" :font-size="bom.font">{{ bom.partsName }}</text>
            <text x="130" :font-size="bom.font">{{ bom.itemNumber }}</text>
            <text x="230" :font-size="bom.font">{{ bom.quantity }}</text>
            <text x="260" :font-size="bom.font">{{ bom.manufactureName }}</text>
            <text x="360" :font-size="bom.font">{{ bom.figureNumber }}</text>
          </g>
        </template>
        <!-- 仕上材リスト -->
        <template v-bind:class="{sheet_info: true, sheet_info_imp: isShowInfo}">
          <g
            v-for="(bom, index) in sheetModel.finishingMaterialList"
            :key="'finishingMaterialList_' + index"
            :transform="'translate(' + bom.startX + ' ' + bom.startY + ') scale(1, -1)'">
            <text x="10" :font-size="bom.font">{{ bom.finishingMaterial }}</text>
          </g>
        </template>
        <!-- 図面グループ単位 -->
        <g
          v-for="(sheetGroup, index) in sheetModel.sheetGroupModelList"
          :key="'sheetGroup_' + index"
        >
          <!-- 図面エリア（デバッグ用）
          <g>
            <rect :x="sheetGroup.startX - sheetGroup.areaWidth/2"
                  :y="sheetGroup.startY - sheetGroup.areaHeight/2"
                  :width="sheetGroup.areaWidth"
                  :height="sheetGroup.areaHeight"
                  fill-opacity="0"
                  stroke="gray"
                  stroke-width="1"/>
          </g>
           -->
          <!-- 図面名 -->
          <g :transform="'translate(' + (sheetGroupLBX(sheetGroup) + 13) + ',' + (sheetGroupLBY(sheetGroup) + 13) + ')' ">
            <text font-size="20" transform="scale(1,-1)">
              {{sheetGroup.sheetTitle}}
            </text>
          </g>
          <!-- 線 -->
          <g>
            <line
              v-for="(line, index) in sheetGroup.linePartsModelList"
              :key="'line_' + index"
              :x1="sheetGroupX(sheetGroup) + line.startX * sheetModel.scale"
              :y1="sheetGroupY(sheetGroup) + line.startY * sheetModel.scale"
              :x2="sheetGroupX(sheetGroup) + line.endX * sheetModel.scale"
              :y2="sheetGroupY(sheetGroup) + line.endY * sheetModel.scale"
              :z="line.z"
              :stroke="line.color ? line.color : 'black'"
              :stroke-width="(line.lineWeight ? line.lineWeight : 1) * svgZoomRatio + 'px'"
              :stroke-dasharray="getDashArray(line)"/>
          </g>
          <!-- 可動棚線 幅の４分の３の位置に出力 -->
          <g
                    v-for="(ms, index) in sheetGroup.movableShelfPointList"
                    :key="'ms_' + index"
                    :stroke-width="(ms.lineWeight ? ms.lineWeight : 1) * svgZoomRatio + 'px'"
                    fill="none"
                    stroke="black"
          >
            <path
                      :d="'M ' + (sheetGroupX(sheetGroup) + ms.x * sheetModel.scale) + ' ' + (sheetGroupY(sheetGroup) + ms.y * sheetModel.scale)
                        + ' v ' + (30 * sheetModel.scale)
                        + ' l ' + (10 * sheetModel.scale) + ' ' + (-20 * sheetModel.scale)" />
            <path
                      :d="'M ' + (sheetGroupX(sheetGroup) + ms.x * sheetModel.scale) + ' ' + (sheetGroupY(sheetGroup) + ms.y * sheetModel.scale)
                        + ' v ' + (-30 * sheetModel.scale)
                        + ' l ' + (-10 * sheetModel.scale) + ' ' + (20 * sheetModel.scale)" />
          </g>
          <!-- 木目方向線 幅の４分の１か高さの４分の３の位置に出力 -->
          <g
                    v-for="(grain, index) in sheetGroup.grainLineList"
                    :key="'grain_' + index"
                    :stroke-width="(grain.lineWeight ? grain.lineWeight : 1) * svgZoomRatio + 'px'"
                    fill="none"
                    stroke="black"
          >
            <line
                    :x1="sheetGroupX(sheetGroup) + grain.startX * sheetModel.scale"
                    :y1="sheetGroupY(sheetGroup) + grain.startY * sheetModel.scale"
                    :x2="sheetGroupX(sheetGroup) + grain.endX * sheetModel.scale"
                    :y2="sheetGroupY(sheetGroup) + grain.endY * sheetModel.scale"
                    z="0"
                    :stroke="grain.color ? grain.color : 'black'"
                    :stroke-width="(grain.lineWeight ? grain.lineWeight : 1) * svgZoomRatio + 'px'"
                    :stroke-dasharray="getDashArray(grain)"/>
            <path v-if="grain.startArrow"
                      :d="'M ' + (sheetGroupX(sheetGroup) + (grain.startX + grain.arrowX) * sheetModel.scale) + ' ' + (sheetGroupY(sheetGroup) + (grain.startY + grain.arrowY) * sheetModel.scale)
                        + ' l ' + (-grain.arrowX * sheetModel.scale) + ' ' + (-grain.arrowY * sheetModel.scale)
                        + ' l ' + (grain.arrowX * sheetModel.scale) + ' ' + (-grain.arrowY * sheetModel.scale)"
                        :transform="'rotate(' + grain.angle + ', ' + (sheetGroupX(sheetGroup) + grain.startX * sheetModel.scale) +', ' + (sheetGroupY(sheetGroup) + grain.startY * sheetModel.scale) + ')'"/>
            <path v-if="grain.endArrow"
                      :d="'M ' + (sheetGroupX(sheetGroup) + (grain.endX - grain.arrowX) * sheetModel.scale) + ' ' + (sheetGroupY(sheetGroup) + (grain.endY + grain.arrowY) * sheetModel.scale)
                        + ' l ' + (grain.arrowX * sheetModel.scale) + ' ' + (-grain.arrowY * sheetModel.scale)
                        + ' l ' + (-grain.arrowX * sheetModel.scale) + ' ' + (-grain.arrowY * sheetModel.scale)"
                        :transform="'rotate(' + grain.angle + ', ' + (sheetGroupX(sheetGroup) + grain.endX * sheetModel.scale) +', ' + (sheetGroupY(sheetGroup) + grain.endY * sheetModel.scale) + ')'"/>
          </g>
          <!-- 円 -->
          <g>
            <circle
              v-for="(circle, index) in sheetGroup.circlePartsModelList"
              :key="'circle_' + index"
              :cx="sheetGroupX(sheetGroup) + circle.x * sheetModel.scale"
              :cy="sheetGroupY(sheetGroup) + circle.y * sheetModel.scale"
              :r="circle.r * sheetModel.scale"
              :stroke="circle.color ? circle.color : 'black'"
              fill="none"
              :stroke-width="(circle.lineWeight ? circle.lineWeight : 1) * svgZoomRatio + 'px'"
              :stroke-dasharray="getDashArray(circle)" />
          </g>
          <!-- 円弧 -->
          <g>
            <path
              v-for="(arc, index) in sheetGroup.arcPartsModelList"
              :key="'arc_' + index"
              :d="buildPathData(sheetGroup, arc)"
              :stroke="arc.color ? arc.color : 'black'"
              fill="none"
              :stroke-width="(arc.lineWeight ? arc.lineWeight : 1) * svgZoomRatio + 'px'"
              :stroke-dasharray="getDashArray(arc)" />
          </g>
          <!-- 文字 -->
          <g
            v-for="(text, index) in sheetGroup.textPartsModelList"
            :key="'text_' + index"
            :transform="'translate(' + text.x * sheetModel.scale + ' ' + text.y * sheetModel.scale + ') scale(1, -1)'"
          >
            <text :transform="'rotate(-' + text.angle + ')'"
                text-anchor="middle"
                :font-size="text.font ? text.font : '12'">
              {{ text.text }}
            </text>
          </g>
          <!-- 寸法 -->
          <g>
            <!-- 寸法線 -->
            <line
              v-for="(dim, index) in sheetGroup.dimensionPartsModelList"
              :key="'dim_' + index"
              :x1="sheetGroupX(sheetGroup) + dim.startX * sheetModel.scale"
              :y1="sheetGroupY(sheetGroup) + dim.startY * sheetModel.scale"
              :x2="sheetGroupX(sheetGroup) + dim.endX * sheetModel.scale"
              :y2="sheetGroupY(sheetGroup) + dim.endY * sheetModel.scale"
              :stroke="dim.lineColor ? dim.lineColor : 'black'"
              :stroke-width="(dim.lineWeight ? dim.lineWeight : 1) * svgZoomRatio + 'px'" />
            <circle
              v-for="(dimPoint, index) in sheetGroup.dimensionPartsModelList"
              :key="'dimPoint_' + index"
              :cx="sheetGroupX(sheetGroup) + dimPoint.startX * sheetModel.scale"
              :cy="sheetGroupY(sheetGroup) + dimPoint.startY * sheetModel.scale"
              :r="dimPoint.point * svgZoomRatio"
              stroke="black"
              fill="black"
              :stroke-width="dimPoint.lineWeight ? dimPoint.lineWeight : '1px'" />

            <!-- 文字(移動・回転を伴うためグループ化) -->
            <!-- 横内線の文字列（寸法値）が縦内線の文字列とぶつかりにくくするため中央からサイズの４分の１ずらす -->
            <g
              v-for="(dimText, index) in sheetGroup.dimensionPartsModelList"
              v-if="dimText.text"
              :key="'dimText' + index"
              :transform="'translate(' + (sheetGroupX(sheetGroup) + (dimText.startX + dimText.endX) / (dimText.horizontaInside ? 4 : 2) * sheetModel.scale) + ' '
                                      + (sheetGroupY(sheetGroup) + (dimText.startY + dimText.endY) / 2 * sheetModel.scale) + ') '
                        + 'scale(1, -1)'"
            >
              <text
                :transform="'translate(' + dimText.hposition + ',' + dimText.vposition + ') '
                          + 'rotate(-' + (dimText.textAngle ? dimText.textAngle : 0) + ')'"
                text-anchor="middle"
                :font-size="dimText.textSize ? dimText.textSize : '7'"
                :fill="dimText.textColor ? dimText.textColor : 'black'"
              >
                {{ dimText.text }}
              </text>
            </g>
          </g>

          <g>
            <g v-for="(origin, index) in sheetGroup.originMarkerList"
               :key="'origin_' + index"
            >
              <line :x1="sheetGroupX(sheetGroup) + origin.x * sheetModel.scale"
                    :y1="sheetGroupY(sheetGroup) + origin.y * sheetModel.scale"
                    :x2="sheetGroupX(sheetGroup) + origin.vertex1.x * sheetModel.scale"
                    :y2="sheetGroupY(sheetGroup) + origin.vertex1.y * sheetModel.scale"
                    stroke="black"
                    :stroke-width="svgZoomRatio + 'px'"
              />
              <line :x1="sheetGroupX(sheetGroup) + origin.x * sheetModel.scale"
                    :y1="sheetGroupY(sheetGroup) + origin.y * sheetModel.scale"
                    :x2="sheetGroupX(sheetGroup) + origin.vertex2.x * sheetModel.scale"
                    :y2="sheetGroupY(sheetGroup) + origin.vertex2.y * sheetModel.scale"
                    stroke="black"
                    :stroke-width="svgZoomRatio + 'px'"
              />
              <line :x1="sheetGroupX(sheetGroup) + origin.vertex1.x * sheetModel.scale"
                    :y1="sheetGroupY(sheetGroup) + origin.vertex1.y * sheetModel.scale"
                    :x2="sheetGroupX(sheetGroup) + origin.vertex2.x * sheetModel.scale"
                    :y2="sheetGroupY(sheetGroup) + origin.vertex2.y * sheetModel.scale"
                    stroke="black"
                    :stroke-width="svgZoomRatio + 'px'"
              />
            </g>
          </g>

          <g>
            <line
              v-for="(sec, index) in sheetGroup.sectionPointPartsModelList"
              :key="'sec1_' + index"
              :x1="sheetGroupX(sheetGroup) + sec.x * sheetModel.scale"
              :y1="sheetGroupY(sheetGroup) + sec.y * sheetModel.scale"
              :x2="sheetGroupX(sheetGroup) + sec.x * sheetModel.scale + sec.footX"
              :y2="sheetGroupY(sheetGroup) + sec.y * sheetModel.scale + sec.footY"
              :stroke="sec.lineColor ? dim.lineColor : 'black'"
              :stroke-width="1 * svgZoomRatio + 'px'"
            />
            <line
              v-for="(sec, index) in sheetGroup.sectionPointPartsModelList"
              :key="'sec2_' + index"
              :x1="sheetGroupX(sheetGroup) + sec.x * sheetModel.scale"
              :y1="sheetGroupY(sheetGroup) + sec.y * sheetModel.scale"
              :x2="sheetGroupX(sheetGroup) + sec.x * sheetModel.scale + sec.lineX"
              :y2="sheetGroupY(sheetGroup) + sec.y * sheetModel.scale + sec.lineY"
              :stroke="sec.lineColor ? dim.lineColor : 'black'"
              :stroke-width="1 * svgZoomRatio + 'px'"
            />
            <g v-for="(sec, index) in sheetGroup.sectionPointPartsModelList"
               :key="'secLabel_' + index"
               :transform="'translate(' + (sheetGroupX(sheetGroup) + sec.x * sheetModel.scale) + ','
                                        + (sheetGroupY(sheetGroup) + sec.y * sheetModel.scale) + ') '
                         + 'scale(1, -1)'">
              <text
                :transform="'translate(' + sec.textXPos + ',' + sec.textYPos + ')'"
                text-anchor="middle"
                font-size="7"
                fill="black">
                {{ sec.label }}
              </text>
            </g>
          </g>
        </g>
      </svg>
    </div>
</div>
</template>

<script>
import axios from 'axios'
import * as Check from '../../../../../utils/Check'
import * as Api from '../../../../../utils/Api'
import {DC_URL, SVG_MIN_DEFAULT, SVG_ZOOM_RATIO_MIN, SVG_ZOOM_SPEED} from '../../../../../constants/App'
import Modal from '../../../../../components/common/Modal'
import * as CalcUtil from 'lodash/math'

export default {
  name: 'Sheet',
  components: {
    'dd-modal': Modal
  },
  props: {
    spaceJoincd: String,
    isPreview: {
      type: Boolean,
      default: false
    },
    svgWidth: {
      type: String,
      default: '90%'
    },
    svgHeight: {
      type: String,
      default: '100%'
    },
    isShowInfo: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      sheetModel: {},
      selectedSheet: {
        sheetType: null,
        spaceId: null,
        subType: null
      },
      sheetTypeList: [],
      viewX: 0,
      viewY: 0,
      viewWidth: 0,
      viewHeight: 0,
      titleAreaHeight: 0,
      svgZoomRatio: 1,
      center: {
        x: 0,
        y: 0
      },
      viewBox: {
        minX: SVG_MIN_DEFAULT, minY: SVG_MIN_DEFAULT, width: 0, height: 0
      },
      prevPointOnCanvas: {
        x: 0,
        y: 0
      },
      drag: false,
      dragPoint: {
        x: 0,
        y: 0
      }
    }
  },
  computed: {
    sheetViewBox: function () {
      return this.viewBox.minX + ' ' + this.viewBox.minY + ' ' + this.viewBox.width + ' ' + this.viewBox.height
    }
  },
  methods: {
    handleScroll: function (event) {
      // TODO 図面の箇所だけスクロールしない処理をいれる
    },
    getSheet: function () {
      if (!this.spaceJoincd) {
        return
      }
      axios.get(DC_URL.SHEET, {
        params: {
          // 図面種別をURLパラメータで指定している場合は、その図面種別でリクエストする
          // sheetType: this.$route.query.sheetType ? this.$route.query.sheetType : this.selectedSheet.sheetType,
          sheetType: this.selectedSheet.sheetType,
          spaceId: this.selectedSheet.spaceId,
          spaceJoincd: this.spaceJoincd,
          page: Number.isInteger(this.selectedSheet.subType) ? this.selectedSheet.subType - 1 : 0
        }
      }).then(response => {
        console.log('▼▼▼▼　DEBUG:GET SHEET DATA ▼▼▼▼')
        console.log(response)
        console.log('▲▲▲▲　DEBUG:GET SHEET DATA ▲▲▲▲')
        if (response.data.data) {
          this.sheetModel = Object.assign([], response.data.data.sheetModel)
          this.sheetTypeList = response.data.data.sheetTypeList
          if (this.sheetTypeList.length > 0 && this.sheetTypeList[0].optionList != null && this.sheetTypeList[0].optionList.length > 0) {
            this.selectedSheet.sheetType = this.sheetTypeList.find(e => e.sheetType === this.sheetModel.sheetType).sheetTypeValue
            this.selectedSheet.spaceId = this.selectedSheet.spaceId != null ? this.selectedSheet.spaceId : this.sheetTypeList[0].optionList[0].spaceId
            this.selectedSheet.subType = Number.isInteger(this.selectedSheet.subType) ? this.selectedSheet.subType : this.sheetTypeList[0].optionList[0].objectSubType
            this.viewWidth = this.sheetModel.sheetWidth
            this.viewHeight = this.sheetModel.sheetHeight
            this.titleAreaHeight = this.sheetModel.titleAreaHeight
            this.viewBox.minX = 0
            this.viewBox.minY = 0
            this.viewBox.width = this.viewWidth
            this.viewBox.height = this.viewHeight
            this.svgZoomRatio = 1
          }
        }
        if (!this.sheetTypeList.length > 0) {
          this.selectedSheet = {}
        }
      }).catch(error => {
        Api.handleError(error)
      }).finally(() => {
        this.$emit('showModal')
      })
    },
    viewBoxForSheetGroup: function (sheetGroup) {
      return (-sheetGroup.leftMargin * this.sheetModel.scale) + ' ' +
              (-sheetGroup.bottomMargin * this.sheetModel.scale) + ' ' +
              this.sheetModel.sheetWidth + ' ' +
              this.sheetModel.sheetHeight
    },
    sheetGroupX: function (sheetGroup) {
      return sheetGroup.startX - (sheetGroup.width / 2) * this.sheetModel.scale
    },
    sheetGroupY: function (sheetGroup) {
      return sheetGroup.startY - (sheetGroup.height / 2) * this.sheetModel.scale
    },
    sheetGroupLBX: function (sheetGroup) {
      return sheetGroup.startX - sheetGroup.areaWidth / 2
    },
    sheetGroupLBY: function (sheetGroup) {
      return sheetGroup.startY - sheetGroup.areaHeight / 2
    },
    mousemoveOnSheet: function (event) {
      if (!this.isPreview) return
      if (this.drag) {
        let moveX = (this.dragPoint.x - event.clientX) * this.svgZoomRatio
        let moveY = (this.dragPoint.y - event.clientY) * this.svgZoomRatio

        this.viewBox.minX += moveX
        this.viewBox.minY -= moveY

        this.setViewBox(this.viewBox.minX + moveX, this.viewBox.minY - moveY, this.viewBox.width, this.viewBox.height)

        this.dragPoint.x = event.clientX
        this.dragPoint.y = event.clientY
      }
    },
    mousedownOnSheet: function (event) {
      if (!this.isPreview) return
      if (event.buttons === 2 && !this.drag) {
        this.drag = true
        this.dragPoint.x = event.clientX
        this.dragPoint.y = event.clientY
      }
    },
    mouseupOnSheet: function (event) {
      if (!this.isPreview) return
      if (this.drag) {
        this.drag = false
      }
    },
    wheelOnSheet: function (event) {
      if (!this.isPreview) return
      this.setCurrentPointerPositionOnCanvas(event, this.viewBox)
      let d
      if (Check.isBrawserIE()) {
        d = Math.sign(event.deltaY)
      } else {
        d = Math.sign(event.wheelDelta)
      }
      this.zoomCanvas(d)
    },
    zoomCanvas: function (wheelAmount) {
      let prevSvgZoomRatio = this.svgZoomRatio
      for (let {threshold, speed} of SVG_ZOOM_SPEED) {
        // ズームインの場合は閾値含まず、ズームアウトの場合は閾値含む
        if ((Math.sign(wheelAmount) > 0 && this.svgZoomRatio > threshold) ||
                (Math.sign(wheelAmount) < 0 && this.svgZoomRatio >= threshold)) {
          this.svgZoomRatio -= Math.sign(wheelAmount) * speed
          break
        }
      }
      // 小数点以下2桁で丸める
      this.svgZoomRatio = Math.round(this.svgZoomRatio * 100) / 100
      if (this.svgZoomRatio < SVG_ZOOM_RATIO_MIN) {
        this.svgZoomRatio = SVG_ZOOM_RATIO_MIN
        return
      }
      // 原寸以下には縮小しない
      if (this.svgZoomRatio >= 1) {
        this.viewBox.minX = 0
        this.viewBox.minY = 0
        this.viewBox.width = this.viewWidth
        this.viewBox.height = this.viewHeight
        this.svgZoomRatio = 1
        return
      }
      // マウスカーソルの位置を基準にズームする
      let x = this.currentPointOnCanvas.x
      let y = this.currentPointOnCanvas.y

      let width = Math.round(this.viewWidth * this.svgZoomRatio)
      let height = Math.round(this.viewHeight * this.svgZoomRatio)

      let tmpZoomRatio = this.svgZoomRatio / prevSvgZoomRatio

      let newMinX = x - (x - this.viewBox.minX) * tmpZoomRatio
      let newMinY = y - (y - this.viewBox.minY) * tmpZoomRatio

      this.setViewBox(newMinX, newMinY, width, height)
    },
    /** 現在のマウスポインタ位置設定(ローカル) */
    setCurrentPointerPositionOnCanvas: function (event, viewBox) {
      this.currentPointOnCanvas = {
        x: CalcUtil.round(event.offsetX * this.svgZoomRatio + viewBox.minX, 1),
        y: CalcUtil.round(event.offsetY * this.svgZoomRatio + viewBox.minY, 1)
      }
    },
    /** SVGのビューボックスに値を設定する */
    setViewBox: function (minX, minY, width, height) {
      this.viewBox.width = width
      this.viewBox.height = height
      if (minX < 0) {
        this.viewBox.minX = 0
      } else if (this.viewWidth < minX + width) {
        this.viewBox.minX = this.viewWidth - width
      } else {
        this.viewBox.minX = minX
      }
      if (minY < 0) {
        this.viewBox.minY = 0
      } else if (this.viewHeight < minY + height) {
        this.viewBox.minY = this.viewHeight - height
      } else {
        this.viewBox.minY = minY
      }
    },
    buildPathData: function (sheetGroup, arc) {
      let scale = this.sheetModel.scale
      let x = this.sheetGroupX(sheetGroup)
      let y = this.sheetGroupY(sheetGroup)
      let d = ''
      d += 'M '
      d += (x + (arc.startX) * scale) + ' '
      d += (y + (arc.startY) * scale) + ' '
      d += 'A '
      d += arc.rw * scale + ' '
      d += arc.rh * scale + ' '
      d += '0 '
      d += (arc.longer ? '1' : '0') + ' '
      d += (arc.cw ? '1' : '0') + ' '
      d += (x + (arc.endX) * scale) + ' '
      d += (y + (arc.endY) * scale)
      return d
    },
    getDashArray: function (parts) {
      let dashed = 3
      if (parts.ltype === 'DOT') {
        dashed *= this.svgZoomRatio
        return dashed + ' ' + dashed + ' '
      }
      return ''
    },
    convertSectionPoints: function (sectionList) {
      return []
    }
  },
  mounted () {
  },
  created: function () {
    // 図面情報の取得
    this.getSheet()
  }
}
</script>
<style src="../../../../css/dctop.scss" lang="scss" scoped></style>
<style src="../../../../css/print.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/components/top/input/estimate/DcEstimateSheet.vue